import { connect } from 'react-redux'
import CashFundPreferencesForm from 'registry/forms/cash-fund-preferences-form'
import { StyledSubHeading } from 'components/headings'
import {
  getCashFundPreferences,
  getRegistryOwnerId,
  getUserId,
} from 'registry/reducers'
import { saveCashFundPreferences } from 'registry/actions'

const CashFundPreferences = (props) => (
  <>
    <StyledSubHeading>Cash Fund Preferences</StyledSubHeading>
    <p className="mbl h6">
      Choose how you'd like to receive money from gift givers. Each option you
      check will be offered to your gift givers to select from.
    </p>
    <CashFundPreferencesForm {...props} />
    {!props.isEditable && (
      <small className="text-muted mbm">
        Only the registry owner can manage cash funds.
      </small>
    )}
  </>
)

const mapStateToProps = (state) => ({
  isEditable: getRegistryOwnerId(state) == getUserId(state),
  preferences: getCashFundPreferences(state),
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleSubmit: (data) => dispatch(saveCashFundPreferences(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashFundPreferences)
